import { render, staticRenderFns } from "./ptRechargeAccount.vue?vue&type=template&id=d008fdb2&scoped=true"
import script from "./ptRechargeAccount.vue?vue&type=script&lang=js"
export * from "./ptRechargeAccount.vue?vue&type=script&lang=js"
import style0 from "./ptRechargeAccount.vue?vue&type=style&index=0&id=d008fdb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d008fdb2",
  null
  
)

export default component.exports